import { DOOR_TYPE, RG_TYPE } from "@project-rouge/rg-core";
var DEFAULTDOOR = DOOR_TYPE.Single;
function getDoorType(space) {
	let singleDoorPresent = false;
	const rooms = space.children.filter((c) => c.type === RG_TYPE.TechnicalSpaceRoom);
	for (const room of rooms) if (room.data.instance.attributes.doorType === DOOR_TYPE.Double) return DOOR_TYPE.Double;
	else if (!singleDoorPresent && room.data.instance.attributes.doorType === DOOR_TYPE.Single) singleDoorPresent = true;
	return singleDoorPresent ? DOOR_TYPE.Single : DEFAULTDOOR;
}
export { getDoorType };

//# sourceMappingURL=index36.js.map